import lrGuid from './_src/lrGuid.vue'
lrGuid.install = function(Vue) {
  Vue.component(lrGuid.name, lrGuid)
}

export default lrGuid